<template>
  <el-dropdown style="padding:0px" @command="handleCommand">
    <span class="el-dropdown-link">
      <!-- 下拉菜单 -->
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command>全部</el-dropdown-item>
      <el-dropdown-item :command="item" v-for="(item, index) in goodsTypeList" :key="index">{{ item }}</el-dropdown-item>
      <!-- <el-dropdown-item command="套餐">套餐</el-dropdown-item> -->
    </el-dropdown-menu>
  </el-dropdown>
</template>
 
<script>
export default {
  data () {
    return {
      value: "",
      goodsTypeList: []
    };
  },
  props: {
    options: {
      type: Array,
      default: function () {
        return [
          { label: "全部", value: "全部" },
          { label: "题库", value: "题库" },
          { label: "套餐", value: "套餐" }
        ];
      }
    }
  },
  watch: {
    defaultValue (newVal, oldVal) {
      let self = this;
      self.value = newVal;
    }
  },
  mounted () {
    this.getGoodsTypeList();
  },
  methods: {
    getGoodsTypeList () {
      this.api.goodsInfo
        .getGoodsTypeList({})
        .then(result => {
          if (result.success) {
            this.goodsTypeList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleCommand (command) {
      console.log('selectHeaderHandleCommand', command)
      this.$emit("selectChange", command);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/goods/SelectHeader.vue